import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Text = styled.p`
  ${tw`my-big text-p-large font-bold text-center`}
`;

export const TextHiglight = styled.span`
  ${tw`rounded-20 bg-accent-yellow-400 px-medium `}
  text-wrap: nowrap;
`;
